// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__JrSbi","label":"SetPasswdForm_label__1TVW9"};